import TenantSelector from './TenantSelector';

export default TenantSelector;
export * from './TenantSelector';
